import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Login from "@/components/Login";
import BrowserIssues from "@/components/browser/Issues";
import {
    Button,
    Calendar,
    Cell,
    CellGroup,
    Col,
    DatetimePicker,
    Divider,
    Field,
    Lazyload,
    NavBar,
    Picker,
    Popup,
    Row,
    Swipe,
    SwipeItem,
    Tabbar,
    TabbarItem,
    Toast,
    Uploader
} from 'vant';
import CMS from "@/components/browser/CMS";
import BrowserEmployees from "@/components/browser/Employees";
import BrowserHome from "@/components/browser/Home";
import BrowserOrganizationStructure from "@/components/browser/OrganizationStructure";
import Axios from 'axios';


Vue.use(Divider);
Vue.use(Calendar);
Vue.use(Col);
Vue.use(Row);
Vue.use(DatetimePicker);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Popup);
Vue.use(Picker);
Vue.use(Field);
Vue.use(Uploader);
Vue.use(Lazyload);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Tabbar);
Vue.use(TabbarItem);
Vue.use(VueRouter)
Vue.use(ElementUI)
Vue.use(NavBar);
Vue.use(Toast);
Vue.use(Button)

Vue.config.productionTip = false

Axios.defaults.headers.common['token'] = localStorage.getItem('token');

const routes = [
    {path: '/', component: Login},
    {path: '/login', component: Login},
    {
        path: '/cms', component: CMS, redirect: '/cms/browser/issues', children: [
            {path: '/browser/issues', component: BrowserIssues},
            {path: '/browser/employees', component: BrowserEmployees},
            {path: '/browser/home', component: BrowserHome},
            {path: '/browser/organization-structure', component: BrowserOrganizationStructure},
        ]
    },
    {path: '/browser/issues', component: BrowserIssues},
];

const router = new VueRouter({
    routes
})

new Vue({
    render: h => h(App),
    router
}).$mount('#app')
